import { HttpClient } from '@angular/common/http';
import {
    IQueryObject,
    queryBuilder,
} from '@pages/monitoring/dashboard/widgets/generics/services/queryBuilder';
import {
    IMonitoringTableQueryOptions,
    IMonitoringTableResponse,
} from '@pages/monitoring/dashboard/widgets/generics/types';
import { toDate } from '@utils/object.utils';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export abstract class MonitoringTableService<T> {
    protected abstract _endpoint: string;

    constructor(private _http: HttpClient) { }

    public get(qo: IMonitoringTableQueryOptions): Observable<IMonitoringTableResponse<T>> {
        return this._http.get<IMonitoringTableResponse<T>>(this._endpoint, {
            params: queryBuilder(qo as IQueryObject),
        })
            .pipe(
                map(r => ({
                    data: toDate(r.data),
                    total: r.total,
                })),
            );
    }
}
